import { render } from "./home-calendar.vue?vue&type=template&id=624308a5"
import script from "./home-calendar.vue?vue&type=script&lang=js"
export * from "./home-calendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__